import React, { useState, useEffect, useContext } from "react";
import TextInput from "components/Input/TextInput.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImageList from "@mui/material/ImageList";
import CustomSwitch from "components/Input/CustomSwitch.js";
import uuid from "react-uuid";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import styled from "styled-components";
import { budgetpagetext } from "variables/budget";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import BudgetContext from "context/BudgetContext";
import FloatInput from "components/Input/FloatInput";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;


function VentilationDialog(props) {

  const { closeModal, refetch, setLoading, currentVentilation, ventilations, setVentilations } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const budgetContext = useContext(BudgetContext);
  const { budget, setBudget } = budgetContext;

  const { chartIdGroup } = advancedSearchContext;

  const [name, setName] = useState(currentVentilation?.name || "");
  const [bypercentage, setBypercentage] = useState(currentVentilation?.bypercentage || false);
  const [amount, setAmount] = useState(currentVentilation?.amount || "");
  const [amountpercentage, setAmountpercentage] = useState(currentVentilation?.amountpercentage || "");

  const [groups, setGroups] = useState(currentVentilation?.groups ? "" + currentVentilation.groups : "");
  const [groupsParent, setGroupsParent] = useState(""+budget?.groupid);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const classes = useStyles();
  const [value, setValue] = useState("0");

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleBypercentageChange = (event) => { setBypercentage(!bypercentage); };
  const handleAmountChange = (event) => { setAmount(event.target.value); };
  const handleAmountpercentageChange = (event) => { setAmountpercentage(event.target.value); };

  useEffect(() => {
    const budgetamount = budget.parameters.general.amount;
    if (bypercentage) {
      let newamount = budgetamount * (amountpercentage/100);
      setAmount(newamount);
    }
    else {
      let newamountpercentage = budgetamount ? (amount / budgetamount)*100 : 0;
      setAmountpercentage(newamountpercentage);
    }
  }, [amount, amountpercentage]);

  const handleSubmit = (event) => {
    if (currentVentilation)
      updateVentilation(event);
    else
      createVentilation(event);
    closeModal();
  };

  useEffect(() => {
    if (!name || !groups || groups.length === 0)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const createVentilation = async (event) => {
    let newventilation = {
      uuid: uuid(),
      name,
      amount,
      amountpercentage,
      bypercentage,
      groups,
    }
    let newventilationlist = [...ventilations];
    newventilationlist.push(newventilation);
    setVentilations(newventilationlist);
    closeModal();
  };

  const updateVentilation = async (event) => {
    let newventilation = {
      uuid: currentVentilation.uuid,
      name,
      amount,
      amountpercentage,
      bypercentage,
      groups,
    }
    let newventilationlist = [...ventilations];
    const indexToReplace = newventilationlist.findIndex((x) => x.uuid === currentVentilation.uuid);
    newventilationlist.splice(indexToReplace, 1, newventilation);
    setVentilations(newventilationlist);
    closeModal();
  }

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <TextInput
                inputTitle={budgetpagetext.ventilation.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <CustomSwitch
                style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                inputTitle={budgetpagetext.ventilation.bypercentage}
                checkedState={bypercentage}
                handleSwitchChange={handleBypercentageChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={budgetpagetext.ventilation.amount}
                floatInput={amount}
                handleFloatInputChange={handleAmountChange}
                disabled={bypercentage}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={budgetpagetext.ventilation.amountpercentage}
                floatInput={amountpercentage}
                handleFloatInputChange={handleAmountpercentageChange}
                disabled={!bypercentage}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  filterfromnode={groupsParent}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default VentilationDialog;
